import axios from 'axios';
import React, { useState } from 'react'
import { Col, FormGroup, Label, Row, Input, Button } from 'reactstrap';
import Swal from 'sweetalert2';


function TokenSwap() {
    /**
     * company_name	site_url	corcern_persn	desgnation	email	phone	token_name	contract_link	tiker_symbol	token_category	trad_pair	white_paper_link	legel_opnion_link	coin_geko_link	coin_market_link	cex_name
     */
    
    const [tokenSwap, setTokenSwap] = useState({
        company_name: '', site_url: '', corcern_persn: '', desgnation: '', email: '',
        phone: '', token_name: '', contract_link: '', tiker_symbol: '', token_category: '', trad_pair: '',
        white_paper_link: '', legel_opnion_link: '', coin_geko_link: '', coin_market_link: '', cex_name: ''
    })

    const handalSubmit = () => {
        if (tokenSwap.company_name === '' || tokenSwap.email === '' ||
            tokenSwap.phone === '' || tokenSwap.token_name === ''
        ) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Please fill up all fields!",
                footer: ''
            });
            return
        }
        axios.post(`${process.env.REACT_APP_API_URL}/token-swap/add`, tokenSwap)


        setTimeout(() => {
            setTokenSwap({
                company_name: '', site_url: '', corcern_persn: '', desgnation: '', email: '',
                phone: '', token_name: '', contract_link: '', tiker_symbol: '', token_category: '', trad_pair: '',
                white_paper_link: '', legel_opnion_link: '', coin_geko_link: '', coin_market_link: '', cex_name: ''
            });
            Swal.fire({
                icon: "success",
                title: "Successfully saved",
                showConfirmButton: false,
                timer: 2000
            });
        }, 1000);
    }

    return (
        <div className="header-offset">
            <div className='bg-one'>
                <h3 className='text-center text-light pt-5'>TOKEN SWAP </h3>
            </div>

            <div>
                <div className='container pt-5 pb-5 new-s token-swap'>
                    <h4 className='pb-5'>
                        Nugget Trap is constantly seeking out new opportunities to expand its value add for its community. We will consider Token swap with other real world asset issuers after an assessment of their Asset and marketability.
                    </h4>
                    <FormGroup row>
                        <Label sm={2} >COMPANY NAME</Label>
                        <Col sm={4}>
                            <Input type="text" value={tokenSwap.company_name}
                        onChange={(e) => { setTokenSwap((prev) => ({ ...prev, company_name: e.target.value })) }}
                            />
                        </Col>
                        <Label sm={2} >WEBSITE</Label>
                        <Col sm={4}>
                            <Input type="text" value={tokenSwap.site_url}
                        onChange={(e) => { setTokenSwap((prev) => ({ ...prev, site_url: e.target.value })) }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2} >CONCERN PERSON</Label>
                        <Col sm={4}>
                            <Input type="text" value={tokenSwap.corcern_persn}
                        onChange={(e) => { setTokenSwap((prev) => ({ ...prev, corcern_persn: e.target.value })) }}
                            />
                        </Col>
                        <Label sm={2} >DESIGNATION</Label>
                        <Col sm={4}>
                            <Input type="text" value={tokenSwap.desgnation}
                        onChange={(e) => { setTokenSwap((prev) => ({ ...prev, desgnation: e.target.value })) }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2} >EMAIL</Label>
                        <Col sm={4}>
                            <Input type="text" value={tokenSwap.email}
                        onChange={(e) => { setTokenSwap((prev) => ({ ...prev, email: e.target.value })) }}
                            />
                        </Col>
                        <Label sm={2} >PHONE</Label>
                        <Col sm={4}>
                            <Input type="text" value={tokenSwap.phone}
                        onChange={(e) => { setTokenSwap((prev) => ({ ...prev, phone: e.target.value })) }}
                            />
                        </Col>
                    </FormGroup>
                    <h3>TOKEN INFORMATION</h3>
                    <hr />
                    <FormGroup row>
                        <Label sm={2} >TOKEN NAME</Label>
                        <Col sm={4}>
                            <Input type="text" value={tokenSwap.token_name}
                        onChange={(e) => { setTokenSwap((prev) => ({ ...prev, token_name: e.target.value })) }}
                            />
                        </Col>
                        <Label sm={2} >SMARTCONTRACT LINK</Label>
                        <Col sm={4}>
                            <Input type="text" value={tokenSwap.contract_link}
                        onChange={(e) => { setTokenSwap((prev) => ({ ...prev, contract_link: e.target.value })) }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2} >TICKER SYMBOL</Label>
                        <Col sm={4}>
                            <Input type="text" value={tokenSwap.tiker_symbol}
                        onChange={(e) => { setTokenSwap((prev) => ({ ...prev, tiker_symbol: e.target.value })) }}
                            />
                        </Col>
                        <Label sm={2} >TOKEN CATEGORY</Label>
                        <Col sm={4}>
                            <Input type="text" value={tokenSwap.token_category}
                        onChange={(e) => { setTokenSwap((prev) => ({ ...prev, token_category: e.target.value })) }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2} >TRADING PAIR</Label>
                        <Col sm={4}>
                            <Input type="text" value={tokenSwap.trad_pair}
                        onChange={(e) => { setTokenSwap((prev) => ({ ...prev, trad_pair: e.target.value })) }}
                            />
                        </Col>
                        <Label sm={2} >WHITEPAPER LINK</Label>
                        <Col sm={4}>
                            <Input type="text" value={tokenSwap.white_paper_link}
                        onChange={(e) => { setTokenSwap((prev) => ({ ...prev, white_paper_link: e.target.value })) }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2} >LEGAL OPINION LINK</Label>
                        <Col sm={4}>
                            <Input type="text" value={tokenSwap.legel_opnion_link}
                        onChange={(e) => { setTokenSwap((prev) => ({ ...prev, legel_opnion_link: e.target.value })) }}
                            />
                        </Col>
                        <Label sm={2} >COINGECKO LINK </Label>
                        <Col sm={4}>
                            <Input type="text" value={tokenSwap.coin_geko_link}
                        onChange={(e) => { setTokenSwap((prev) => ({ ...prev, coin_geko_link: e.target.value })) }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2} >COINMARKETCAP LINK </Label>
                        <Col sm={4}>
                            <Input type="text" value={tokenSwap.coin_market_link}
                        onChange={(e) => { setTokenSwap((prev) => ({ ...prev, coin_market_link: e.target.value })) }}
                            />
                        </Col>
                        <Label sm={2} >CEX NAME</Label>
                        <Col sm={4}>
                            <Input type="text" value={tokenSwap.cex_name}
                        onChange={(e) => { setTokenSwap((prev) => ({ ...prev, cex_name: e.target.value })) }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={12}>
                            <Button type='button' color='primary' block onClick={handalSubmit}>Submit</Button>
                        </Col>
                    </FormGroup>
                </div>
            </div>
        </div>
    )
}

export default TokenSwap